var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"C-fragment C-fragment-html C-fragment-html-md-heading"},[_c('div',{class:("C-title C-title__" + _vm.headlineClass),domProps:{"innerHTML":_vm._s(_vm.headlineText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }